<template>
  <b-modal :hide-header="true" :hide-footer="true" size="lg" :body-class="['p-0']" class="export-activity-success-modal" @hide="onModalClose" scrollable :no-close-on-backdrop="true" style="width: 518px;" v-model="isModalShow">
    <img src="static/img/add.svg" class="rt-2-10 close-icon" style="float: right;" @click="onModalClose" />
    <div class="add-import-activity-json-modal__container pl-20 pt-36">
      <div class="import-success-header-text">{{ title }}</div>
      <div class="import-success-text">
        {{ description }}
      </div>
      <img v-if="isSuccessIcon" class="export-success-img" src="static/img/activity-configurator/green-check-large.png" />
      <div v-if="isModelActions" class="row">
        <button v-if="!onlySubmit" type="button" class="model-action-btns" @click="$emit('onCancelClick')">
          <span class="continue-btn-text">{{ cancelLabel }}</span>
        </button>
        <button type="button" class="model-action-btns" style="background-color: #4c8ce4;" @click="$emit('onSubmitClick')">
          <span class="cancel-btn-text">{{ submitLabel }}</span>
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    title: {
      type: String
    },
    description: {
      type: String
    },
    cancelLabel: {
      type: String,
      default: "Cancel"
    },
    submitLabel: {
      type: String,
      default: "Submit"
    },
    isSuccessIcon: {
      type: Boolean
    },
    isModelActions: {
      type: Boolean
    },
    onlySubmit: {
      type: Boolean
    }
  },
  data() {
    return {
      isModalShow: true
    };
  },
  methods: {
    onModalClose() {
      this.isModalShow = false;
      this.$emit("onModelClose");
    },
    onCancelClick(type) {
      this.$emit("onClick", type);
    }
  },
  mounted() {
    this.isModalShow = true;
  }
};
</script>

<style lang="scss">
.close-icon {
  padding: 7px 7px 0px 0px;
  opacity: 0.5;
  cursor: pointer;
}
.add-import-activity-json-modal__container {
  width: 518px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 42px;
  flex-direction: column;
  .import-success-header-text {
    font-weight: bold;
    font-size: 24px;
    line-height: 1.33;
  }
  .continue-btn-text {
    color: #000;
    font-weight: bold;
  }
  .import-success-text {
    font-size: 18px;
    padding: 18px 40px 24px;
    text-align: center;
  }
  .model-action-btns {
    background-color: #e0e0e0;
    color: #fff;
    border-radius: 100px !important;
    outline: none !important;
    border: none !important;
    padding: 10px 50px !important;
    margin: 0.3125em;
    font-size: 14px;
    line-height: 1.14;
    letter-spacing: 0.5px;
    font-weight: bold;
    cursor: pointer;
  }
}
</style>
